module.exports = __webpack_public_path__ + "img/Home.2ff148aa.svg";